import { PAYMENT_TYPE } from '../../../../main/payment/constants';
import { t } from '../../../../../modules/infra/i18n';

export const PAYMENT_TYPE_KEYS = {
  [PAYMENT_TYPE.cash]: 'common:payment_types.cash',
  [PAYMENT_TYPE.card]: 'common:payment_types.credit_card',
  [PAYMENT_TYPE.giftCard]: 'common:payment_types.gift_card',
  [PAYMENT_TYPE.reader]: 'common:payment_types.card_reader',
  [PAYMENT_TYPE.readerless]: 'common:payment_types.third_party_pos',
};

export const getPaymentTypeLabel = (paymentType) => {
  return t(PAYMENT_TYPE_KEYS[paymentType] || 'common:payment_types.unknown');
};

export const ASSIGN_PAYMENTS = 'payment/ASSIGN_PAYMENTS';
export const REMOVE_PAYMENT = 'payment/REMOVE_PAYMENT';
